import { render, staticRenderFns } from "./PageReviewLearningUnitList.vue?vue&type=template&id=76f24a44&"
import script from "./PageReviewLearningUnitList.vue?vue&type=script&lang=js&"
export * from "./PageReviewLearningUnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports